import React, { useEffect } from 'react';
export const FormContainer = ({ children, onSubmit }) => {
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const handleKeyDown = (event) => {
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            if (onSubmit) {
                onSubmit();
            }
        }
    };
    return React.createElement("div", { className: "form-container" }, children);
};
